import {
  ApplicationConfig,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { routerReducer, provideRouterStore } from '@ngrx/router-store';
import { BreadcrumbsReducer, ContactReducer, ContactEffects, GeneralReducer, GeneralEffects, GuidelinesReducer, PagesReducer, PagesEffects, SearchReducer, SearchEffects } from './store';
import { provideEffects } from '@ngrx/effects';
import { CookieService } from 'ngx-cookie-service';
import { appInitializer } from './app.initializer';
import { LocalizationReducer, LanguageService, SERVER_BASE_URL } from '@ca/ca-ng-core';
import { provideHttpClient } from '@angular/common/http';
import { CmsService } from './services/cms.service';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      appRoutes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled', // restore on back/forward, scroll top on new nav
        anchorScrolling: 'enabled',
      })
    ),
    provideStore(
      {
        general: GeneralReducer,
        router: routerReducer,
        search: SearchReducer,
        contact: ContactReducer,
        breadcrumbs: BreadcrumbsReducer,
        pages: PagesReducer,
        localization: LocalizationReducer,
        guidelines: GuidelinesReducer
      }
    ),
    provideRouterStore(), // Syncs router state with NgRx store
    provideEffects([GeneralEffects, PagesEffects, SearchEffects, ContactEffects]),
    provideStoreDevtools({ maxAge: 25, logOnly: false }), // Enable Redux DevTools
    {
      provide: SERVER_BASE_URL,
      useValue: environment.apiBaseUrl
    },
    CookieService,
    LanguageService,
    CmsService,
    provideHttpClient(),
    provideAppInitializer(appInitializer()),
  ],
};
